/* eslint-disable import/no-anonymous-default-export */
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

// Translation function using Google Translate ONLY
const translateText = async (text, targetLanguage, sourceLanguage = "en") => {
  if (!text || !text.trim() || targetLanguage === sourceLanguage) return text;
  const cleanText = text.trim();
  try {
    const response = await fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLanguage}&tl=${targetLanguage}&dt=t&q=${encodeURIComponent(
        cleanText
      )}`
    );

    if (response.ok) {
      const data = await response.json();

      if (data && data[0] && data[0][0] && data[0][0][0]) {
        return data[0][0][0];
      }
    }
  } catch (error) {
    console.warn("Google Translate failed:", error);
  }
  return cleanText;
};

// Function for API services (outside React components)
export const translateErrorMessage = async (message) => {
  const currentLang = localStorage.getItem("is_language") || "en";

  if (!message || currentLang === "en") {
    return message;
  }

  return await translateText(message, currentLang, "en");
};

// React hook for components
export const useErrorTranslation = () => {
  const { i18n } = useTranslation();

  const currentLang = i18n.language;

  const translateError = useCallback(
    async (errorMessage) => {
      if (!errorMessage || currentLang === "en") {
        return errorMessage;
      }

      return await translateText(errorMessage, currentLang, "en");
    },
    [currentLang]
  );

  return { translateError, currentLanguage: currentLang };
};

export default { useErrorTranslation, translateErrorMessage };
